module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем активность пользователя..."
    }
  }) : _c('div', {
    staticClass: "steamline"
  }, _vm._l((_vm.logsPage.logs), function(log) {
    return _c('div', {
      staticClass: "sl-item"
    }, [_c('div', {
      staticClass: "sl-left"
    }, [_c('i', {
      staticClass: "fa fa-code-fork"
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(log.diffForHumans) + " (" + _vm._s(log.date) + " в " + _vm._s(log.time) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(log.text) + " "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOrderDetail(log.objectId)
        }
      }
    }, [_vm._v("№" + _vm._s(log.objectId))])])])
  })), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.logsPage.paginator.total_count,
      "per-page": _vm.logsPage.paginator.limit
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f1bcf9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-2f1bcf9c"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/Timeline.vue
// module id = 1021
// module chunks = 1